import React, { PureComponent } from 'react';
import { View } from 'react-native';
import { Text } from '@dkrm/ui-kit-basic';
import { bool, string, func, node } from 'prop-types';
import { stylePropTypes } from '@dkrm/general-libs/theme/styles';
import TouchableNativeFeedbackOpacity from '../../TouchableNativeFeedbackOpacity';
import BaseCheckBox from '../BaseCheckBox';
import styles from './styles';
export default class CheckBoxRow extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handlePress = () => this.props.onChange(!this.props.checked);
  }
  render() {
    const {
      leftComponent,
      rightComponent,
      checked,
      title,
      description,
      containerStyle,
      textStyle,
      titleStyle,
      errorMessage,
      disabled
    } = this.props;
    return /*#__PURE__*/React.createElement(TouchableNativeFeedbackOpacity, {
      style: [styles.container, containerStyle],
      onPress: this.handlePress
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.container, containerStyle]
    }, leftComponent && /*#__PURE__*/React.createElement(View, {
      style: styles.leftContainer
    }, leftComponent), /*#__PURE__*/React.createElement(View, {
      style: styles.textContainer
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.title, textStyle, titleStyle]
    }, title), rightComponent && /*#__PURE__*/React.createElement(View, {
      style: styles.rightContainer
    }, rightComponent)), description && /*#__PURE__*/React.createElement(Text, {
      style: [styles.description, textStyle]
    }, description), errorMessage && /*#__PURE__*/React.createElement(Text, {
      style: [styles.errorMessage, textStyle]
    }, errorMessage)), /*#__PURE__*/React.createElement(View, {
      style: styles.rightContainer
    }, /*#__PURE__*/React.createElement(BaseCheckBox, {
      checked: checked,
      disabled: disabled
    }))));
  }
}
CheckBoxRow.defaultProps = {
  checked: false,
  onChange: () => {},
  description: undefined,
  leftComponent: null,
  rightComponent: null,
  containerStyle: null,
  textStyle: null,
  titleStyle: null,
  errorMessage: undefined,
  disabled: false
};
CheckBoxRow.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: bool,
  onChange: func,
  title: string.isRequired,
  description: string,
  leftComponent: node,
  rightComponent: node,
  containerStyle: stylePropTypes,
  textStyle: stylePropTypes,
  titleStyle: stylePropTypes,
  errorMessage: string,
  disabled: bool
} : {};